  export const call_to_action_options = [
    { value: 'SHOP_NOW', label: 'Shop now' },
    { value: 'LEARN_MORE', label: 'Learn more' },
    { value: 'APPLY_NOW', label: 'Apply now' },
    { value: 'ORDER_NOW', label: 'Order now' },
    { value: 'BOOK_TRAVEL', label: 'Book now' },
    { value: 'BUY_TICKETS', label: 'Buy tickets' },
    { value: 'CONTACT_US', label: 'Contact us' },
    { value: 'GET_QUOTE', label: 'Get quote' },
    { value: 'SIGN_UP', label: 'Sign up' },
    { value: 'SUBSCRIBE', label: 'Subscribe' },
    { value: 'GET_OFFER_VIEW', label: 'Get offer' }
  ];

  
  export const call_to_action_options_instantForms = [
    { value: 'SUBSCRIBE', label: 'Subscribe' },
    { value: 'APPLY_NOW', label: 'Apply now' },
    { value: 'GET_QUOTE', label: 'Get quote' },
    { value: 'DOWNLOAD', label: 'Download' },
    { value: 'BOOK_TRAVEL', label: 'Book now' },
    { value: 'SIGN_UP', label: 'Sign up' },
    { value: 'LEARN_MORE', label: 'Learn more' }, 
    { value: 'GET_OFFER_VIEW', label: 'Get offer' },
    { value: 'GET_IN_TOUCH', label: 'Get in touch' } 
  ];
  
  export const call_to_action_options_app_promptions = [
    { value: 'SIGN_UP', label: 'Sign up' },
    { value: 'SUBSCRIBE', label: 'Subscribe' },
    { value: 'USE_APP', label: 'Use app' },
    { value: 'WATCH_MORE', label: 'Watch more' },
    { value: 'SHOP_NOW', label: 'Shop now' },
    { value: 'BOOK_TRAVEL', label: 'Book now' },
    { value: 'DOWNLOAD', label: 'Download' },
    { value: 'EXPLORE_MORE', label: 'Explore more' },
    { value: 'INSTALL_MOBILE_APP', label: 'Install now' },
    { value: 'LEARN_MORE', label: 'Learn more' },
    { value: 'LISTEN_NOW', label: 'Listen now' },
    { value: 'ORDER_NOW', label: 'Order now' },
    { value: 'PLAY_GAME', label: 'Play game' },
    { value: 'APPLY_NOW', label: 'Apply now' },
    { value: 'BUY_TICKETS', label: 'Buy tickets' },
    { value: 'CONTACT_US', label: 'Contact us' },
    { value: 'GET_QUOTE', label: 'Get quote' },
    { value: 'GET_OFFER_VIEW', label: 'Get offer' }
  ];
  

  export const call_to_action_options_for_app_leads_and_sales = [
      { value: 'USE_MOBILE_APP', label: 'Use app' },
      { value: 'SHOP_NOW', label: 'Shop now' },
      { value: 'LEARN_MORE', label: 'Learn more' },
      { value: 'APPLY_NOW', label: 'Apply now' },
      { value: 'DOWNLOAD', label: 'Download' },
      { value: 'SUBSCRIBE', label: 'Subscribe' },
      { value: 'SIGN_UP', label: 'Sign up' },
      { value: 'PLAY_GAME', label: 'Play game' },
      { value: 'ORDER_NOW', label: 'Order now' },
      { value: 'BOOK_TRAVEL', label: 'Book now' },
      { value: 'LISTEN_NOW', label: 'Listen now' },
  ];

  export const call_to_action_options_whatsapp = [
    { value: 'WHATSAPP_MESSAGE', label: 'Send WhatsApp message' },
    { value: 'PLAY_GAME', label: 'Play game' },
    { value: 'APPLY_NOW', label: 'Apply now' },
    { value: 'SUBSCRIBE', label: 'Subscribe' },
    { value: 'SIGN_UP', label: 'Sign up' },
    { value: 'ORDER_NOW', label: 'Order now' },
    { value: 'LEARN_MORE', label: 'Learn more' },
    { value: 'BOOK_TRAVEL', label: 'Book now' },
    { value: 'CONTACT_US', label: 'Contact us' },
    { value: 'GET_QUOTE', label: 'Get quote' },
  ];

  export const call_to_action_options_Awareness_Traffic_Engagement = [
    { value: 'ORDER_NOW', label: 'Order now' },
    { value: 'APPLY_NOW', label: 'Apply now' },
    { value: 'BOOK_TRAVEL', label: 'Book now' },
    { value: 'BUY_TICKETS', label: 'Buy tickets' },
    { value: 'CONTACT_US', label: 'Contact us' },
    { value: 'GET_QUOTE', label: 'Get quote' },
    { value: 'LEARN_MORE', label: 'Learn more' },
    { value: 'SHOP_NOW', label: 'Shop now' },
    { value: 'SIGN_UP', label: 'Sign up' },
    { value: 'SUBSCRIBE', label: 'Subscribe' },
    { value: 'GET_OFFER_VIEW', label: 'Get offer' }
  ];  


  
  
  